import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { conditionsActions } from '../constants';

const fetchConditions = withDraft((draft) => {
  draft.conditions.readStatus = states.PENDING;
  draft.conditions.readErrors = [];
});

const fetchConditionsSuccess = withDraft((draft, action) => {
  draft.conditions.readStatus = states.SUCCESS;
  draft.conditions.readErrors = [];
  draft.conditions.results = action.results;
});

const fetchConditionsError = withDraft((draft, action) => {
  draft.conditions.readStatus = states.ERROR;
  draft.conditions.readErrors = [responseError(action)];
});

export default {
  [conditionsActions.FETCH_CONDITIONS]: fetchConditions,
  [conditionsActions.FETCH_CONDITIONS_ERROR]: fetchConditionsError,
  [conditionsActions.FETCH_CONDITIONS_SUCCESS]: fetchConditionsSuccess,
};
